import React, { PropTypes } from 'react';

const FlexContent = ((props) => {
  const { children, className } = props;
  return (
    <div className={ `flex-content ${ className }` }>
      { children }
    </div>
  );
});

FlexContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default FlexContent;
